"use strict";
/**
 * Created by Ning Jiang on 5/17/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenEvent = void 0;
class ScreenEvent {
}
ScreenEvent.GAME_RESTORE = "screenEvent_gameRestore";
ScreenEvent.GAME_READY = "screenEvent_gameReady";
ScreenEvent.GAME_START = "screenEvent_gameStart";
ScreenEvent.SCREEN_START = "screenEvent_screenStart";
ScreenEvent.SCREEN_CLOSED = "screenEvent_screenClosed";
ScreenEvent.PICK_AND_CLICK_START = "screenEvent_pickAndClickStart";
ScreenEvent.PICK_AND_CLICK_CLOSED = "screenEvent_pickAndClickClosed";
ScreenEvent.BET_OPTION_CHANGED = "screenEvent_betOptionChanged";
exports.ScreenEvent = ScreenEvent;
//# sourceMappingURL=ScreenEvent.js.map